import { BillSourceType } from "./BillSourceType";
import { SubProcessType } from "./SubProcessType";

export class CallActivitySubProcess {
    calledBizDefKey: string;
    calledBizDefName: string;
    calledElement: string;
    calledElementName: string;
    bizDataId: string;
    inheritVariables: boolean;
    inheritBizDataId: boolean;
    useAutoCreationData: boolean;
    aifProcessCode: string;
    aifProcessName: string;
    subProcessType: SubProcessType = SubProcessType.Specified;
    billSourceType: BillSourceType = BillSourceType.InheritParent;
}
